/* eslint-disable import/prefer-default-export */

// landmark
export const getLandmarkRatingData = (article) => {
  const tripsWithRating = article.section_ids
    .filter(section => section.contains === 'trips' && section.trip_ids)
    .reduce((acc, cur) => [...acc, ...cur.trip_ids], [])
    .filter(trip => !!trip.rating);
  const rating = tripsWithRating.reduce((acc, cur) => acc + cur.rating, 0);
  const ratingCount = tripsWithRating.reduce((acc, cur) => acc + cur.review_count + cur.travelers_without_review, 0);
  const reviewCount = tripsWithRating.reduce((acc, cur) => acc + cur.review_count, 0);
  const averageRating = Number((rating / tripsWithRating.length).toFixed(1));
  return {
    ratingCount,
    reviewCount,
    averageRating
  };
};
